import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-2xl font-bold">
              <span className="text-white">wallers</span>
              <span className="text-purple-500">.gg</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/products" className="text-gray-300 hover:text-white transition-colors">
              Products
            </Link>
            <a href="https://discord.gg/GnhVEpups" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
              Discord
            </a>
            <Link to="/payment-methods" className="text-gray-300 hover:text-white transition-colors">
              Payment Methods
            </Link>
            <Link to="/status" className="text-gray-300 hover:text-white transition-colors">
              Status
            </Link>
            <Link to="/cart" className="relative text-gray-300 hover:text-white transition-colors">
              <ShoppingCart size={20} />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-purple-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </Link>
            <Link to="/dashboard" className="bg-purple-600 hover:bg-purple-700 text-white inline-flex items-center justify-center rounded-md px-4 py-2 font-medium transition-colors">
              Dashboard
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-300 hover:text-white"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-black/95 border-t border-white/10">
          <div className="px-4 pt-2 pb-3 space-y-1">
            <Link to="/products" className="block px-3 py-2 text-gray-300 hover:text-white transition-colors">
              Products
            </Link>
            <a href="https://discord.gg/GnhVEpups" target="_blank" rel="noopener noreferrer" className="block px-3 py-2 text-gray-300 hover:text-white transition-colors">
              Discord
            </a>
            <Link to="/payment-methods" className="block px-3 py-2 text-gray-300 hover:text-white transition-colors">
              Payment Methods
            </Link>
            <Link to="/status" className="block px-3 py-2 text-gray-300 hover:text-white transition-colors">
              Status
            </Link>
            <Link to="/cart" className="block px-3 py-2 text-gray-300 hover:text-white transition-colors flex items-center justify-between">
              <span>Cart</span>
              {cartCount > 0 && (
                <span className="bg-purple-600 text-white text-xs rounded-full px-2 py-1">
                  {cartCount}
                </span>
              )}
            </Link>
            <Link to="/dashboard" className="w-full bg-purple-600 hover:bg-purple-700 text-white mt-2 inline-flex items-center justify-center rounded-md px-4 py-2 font-medium">
              Dashboard
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
